import { gql } from '@apollo/client';

export const GET_USER_DATA = gql`
  query GetUserData {
    getUserById {
      profileType
      id
      name
      email
      phoneNumber
      dateJoined
      organisation {
        id
        name
        address
        userQuota
        organisationType
        isActive
        communicationEmail
        organisationSubscription {
          litigator
          contract
        }
      }

      contractUserSetting {
        id
        userSubscriptions {
          service
          quota
          isActive
        }
        tourStatuses {
          service
          hasTakenTour
          id
          reminderDate
          created
          modified
        }
      }
    }
  }
`;
